export default {
      id: "circle-mail-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-mail-usage",
      toString: function () {
        return this.url;
      }
    }